































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { appModule } from "@/store/modules/app";
import PermintaanObatPaketSvc from "@/services/PermintaanObatPaket";
import PaketObatForm from "./PaketObatForm.vue";
import { PAKET_OBAT, PaketObatConfig } from "./paketObat.config";

@Component({
  components: {
    PaketObatForm,
  },
  inject: {
    isReadOnly: { default: () => () => false },
  },
})
export default class PaketObatList extends Vue {
  @Prop({ type: String, required: true }) jenisPaket!: string;
  @Prop() register!: string;
  @Prop() rm!: string;

  isReadOnly!: () => boolean;

  get cfg(): PaketObatConfig {
    return PAKET_OBAT[this.jenisPaket];
  }

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  showForm = false;
  showDetail = false;
  selectedItem: any = null;
  editData: any = null;
  confirmDelete = false;
  deleteTarget: any = null;
  deleting = false;
  loading = false;

  items: any[] = [];

  tableHeaders = [
    { text: "Nama DPJP", value: "dpjp", width: "200px", sortable: false },
    { text: "Diagnosa", value: "diagnosa", sortable: false },
    { text: "Jenis Bayar", value: "jenis_bayar", width: "120px", sortable: false },
    { text: "Items", value: "total_items", width: "80px", sortable: false },
    { text: "TTD DPJP", value: "signed_dpjp", width: "100px", sortable: false },
    { text: "Aksi", value: "actions", sortable: false, width: "160px" },
  ];

  get hasData() {
    return this.items.length > 0;
  }

  mounted() {
    this.loadList();
  }

  @Watch("register")
  onRegisterChange() {
    this.showForm = false;
    this.showDetail = false;
    this.loadList();
  }

  async loadList() {
    this.loading = true;
    try {
      const resp = await PermintaanObatPaketSvc.getByRegister(this.register, this.jenisPaket);
      if (resp.data.status === "1" && resp.data.data) {
        this.items = [resp.data.data];
      } else {
        this.items = [];
      }
    } catch {
      this.items = [];
    }
    this.loading = false;
  }

  tambah() {
    this.showForm = true;
    this.editData = null;
  }

  lihat(item: any) {
    this.selectedItem = item;
    this.showDetail = true;
  }

  edit(item: any) {
    this.editData = item;
    this.showForm = true;
  }

  cancelForm() {
    this.showForm = false;
    this.editData = null;
  }

  onSaved() {
    this.showForm = false;
    this.showDetail = false;
    this.editData = null;
    this.selectedItem = null;
    this.loadList();
  }

  cetakPdf(item: any) {
    PermintaanObatPaketSvc.print(item.id);
  }

  hapus(item: any) {
    this.deleteTarget = item;
    this.confirmDelete = true;
  }

  async doDelete() {
    if (!this.deleteTarget) return;
    this.deleting = true;
    try {
      const resp = await PermintaanObatPaketSvc.destroy(this.deleteTarget.id);
      if (resp && resp.status == 1) {
        appModule.NoticeDelay("Berhasil menghapus permintaan");
        this.confirmDelete = false;
        this.deleteTarget = null;
        await this.loadList();
      }
    } catch {
      // handled by service
    } finally {
      this.deleting = false;
    }
  }
}
